import { SafeHtml } from "@angular/platform-browser";

export class PatientNotesDetailParam {
    PatientID: number;
    GPSubjectID: number | null;
    ObjectType: string;
    ObjectID: number | null;
    OffSetRows: number;
    NextRows: number;
    IncludeOffset: number;

}

export class PatientSOAPNotesParams {
    soapNotesID: number;
    patientID: number | null;
    subject: string;
    object: string;
    assessment: string;
    planning: string;
    signature: string;
    isSigned: boolean | null;
    isActive: boolean | null;
    isDeleted: boolean | null;
    addedOn: string | null;
    addedBy: number | null;
    updatedOn: string | null;
    updatedBy: number | null;
}

export class MenuParams {
    userID: number;
    roleID: number | null;
    branchID: number;
}

export class Menu {
  menuId: number;
  parentId: number | null;
  menuText: string;
  routeUrl: string | null;
  iconClass: SafeHtml | null;
  sortOrder: number;
  isActive: boolean;
}
